export const EmailInput = {
  mounted() {
    this.el.focus()
    this.el.addEventListener("input", (e) => {
      const email_input = this.el
      if (email_input.value.startsWith("mailto:")) {
        email_input.value = email_input.value.split("mailto:")[1]
      }
    })
  },
}
